import {gsap} from "../lib/gsap";
import {ScrollTrigger} from "../lib/gsap/ScrollTrigger";
import {ScrollSmoother} from "../lib/gsap/ScrollSmoother";
import {SplitText} from "../lib/gsap/SplitText";
import {Observer} from "../lib/gsap/Observer";
import {Draggable} from "../lib/gsap/Draggable";
import {ScrollToPlugin} from "../lib/gsap/ScrollToPlugin";

import PhotoSwipeLightbox from "../lib/photoswipe/photoswipe-lightbox.esm.min.js";
import PhotoSwipeDynamicCaption from "../lib/photoswipe/photoswipe-dynamic-caption-plugin.esm.js";
import PhotoSwipe from "../lib/photoswipe/photoswipe.esm.min.js";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText, Observer, Draggable, ScrollToPlugin);

export {ScrollTrigger};
export {ScrollSmoother};
export {SplitText};
export {Observer};
export {Draggable};
export {ScrollToPlugin};
export {PhotoSwipeLightbox, PhotoSwipeDynamicCaption, PhotoSwipe};
export {gsap};


